exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropzone[data-v-3da7b7d8] .dz-message {\n    padding: 1rem 1rem;\n    cursor: pointer;\n}\n.dropzone[data-v-3da7b7d8] .dz-message .dz-button {\n    background: hsla(0,0%,100%,0);\n    border: none;\n    color: #8898aa;\n    cursor: pointer;\n}\n.dropzone[data-v-3da7b7d8] .dz-preview-img {\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n}\n\n", ""]);

// exports
